/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { UnistackImageListRsp } from '../models/unistack-image-list-rsp';
import { UnistackImageCreateRsp } from '../models/unistack-image-create-rsp';
import { UnistackImageCreateReq } from '../models/unistack-image-create-req';
import { UnistackImageLookupRsp } from '../models/unistack-image-lookup-rsp';
import { UnistackImageDeleteRsp } from '../models/unistack-image-delete-rsp';
@Injectable({
  providedIn: 'root',
})
class ImageServiceService extends __BaseService {
  static readonly ImageListPath = '/api/unistack/v0/images';
  static readonly ImageCreatePath = '/api/unistack/v0/images';
  static readonly ImageLookupPath = '/api/unistack/v0/images/{uuid}';
  static readonly ImageDeletePath = '/api/unistack/v0/images/{uuid}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `ImageServiceService.ImageListParams` containing the following parameters:
   *
   * - `type`:
   *
   * - `meta.sort`:
   *
   * - `meta.order`:
   *
   * - `meta.offset`:
   *
   * - `meta.limit`:
   *
   * - `fields`:
   *
   * @return A successful response.
   */
  ImageListResponse(params: ImageServiceService.ImageListParams): __Observable<__StrictHttpResponse<UnistackImageListRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.type != null) __params = __params.set('type', params.type.toString());
    if (params.metaSort != null) __params = __params.set('meta.sort', params.metaSort.toString());
    if (params.metaOrder != null) __params = __params.set('meta.order', params.metaOrder.toString());
    if (params.metaOffset != null) __params = __params.set('meta.offset', params.metaOffset.toString());
    if (params.metaLimit != null) __params = __params.set('meta.limit', params.metaLimit.toString());
    (params.fields || []).forEach(val => {if (val != null) __params = __params.append('fields', val.toString())});
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/unistack/v0/images`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackImageListRsp>;
      })
    );
  }
  /**
   * @param params The `ImageServiceService.ImageListParams` containing the following parameters:
   *
   * - `type`:
   *
   * - `meta.sort`:
   *
   * - `meta.order`:
   *
   * - `meta.offset`:
   *
   * - `meta.limit`:
   *
   * - `fields`:
   *
   * @return A successful response.
   */
  ImageList(params: ImageServiceService.ImageListParams): __Observable<UnistackImageListRsp> {
    return this.ImageListResponse(params).pipe(
      __map(_r => _r.body as UnistackImageListRsp)
    );
  }

  /**
   * @param body undefined
   * @return A successful response.
   */
  ImageCreateResponse(body: UnistackImageCreateReq): __Observable<__StrictHttpResponse<UnistackImageCreateRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/unistack/v0/images`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackImageCreateRsp>;
      })
    );
  }
  /**
   * @param body undefined
   * @return A successful response.
   */
  ImageCreate(body: UnistackImageCreateReq): __Observable<UnistackImageCreateRsp> {
    return this.ImageCreateResponse(body).pipe(
      __map(_r => _r.body as UnistackImageCreateRsp)
    );
  }

  /**
   * @param params The `ImageServiceService.ImageLookupParams` containing the following parameters:
   *
   * - `uuid`:
   *
   * - `label`:
   *
   * @return A successful response.
   */
  ImageLookupResponse(params: ImageServiceService.ImageLookupParams): __Observable<__StrictHttpResponse<UnistackImageLookupRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.label != null) __params = __params.set('label', params.label.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/unistack/v0/images/${params.uuid}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackImageLookupRsp>;
      })
    );
  }
  /**
   * @param params The `ImageServiceService.ImageLookupParams` containing the following parameters:
   *
   * - `uuid`:
   *
   * - `label`:
   *
   * @return A successful response.
   */
  ImageLookup(params: ImageServiceService.ImageLookupParams): __Observable<UnistackImageLookupRsp> {
    return this.ImageLookupResponse(params).pipe(
      __map(_r => _r.body as UnistackImageLookupRsp)
    );
  }

  /**
   * @param params The `ImageServiceService.ImageDeleteParams` containing the following parameters:
   *
   * - `uuid`:
   *
   * - `volume`:
   *
   * @return A successful response.
   */
  ImageDeleteResponse(params: ImageServiceService.ImageDeleteParams): __Observable<__StrictHttpResponse<UnistackImageDeleteRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.volume != null) __params = __params.set('volume', params.volume.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/unistack/v0/images/${params.uuid}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackImageDeleteRsp>;
      })
    );
  }
  /**
   * @param params The `ImageServiceService.ImageDeleteParams` containing the following parameters:
   *
   * - `uuid`:
   *
   * - `volume`:
   *
   * @return A successful response.
   */
  ImageDelete(params: ImageServiceService.ImageDeleteParams): __Observable<UnistackImageDeleteRsp> {
    return this.ImageDeleteResponse(params).pipe(
      __map(_r => _r.body as UnistackImageDeleteRsp)
    );
  }
}

module ImageServiceService {

  /**
   * Parameters for ImageList
   */
  export interface ImageListParams {
    type?: string;
    metaSort?: string;
    metaOrder?: string;
    metaOffset?: string;
    metaLimit?: string;
    fields?: Array<'field_all' | 'field_name' | 'field_version' | 'field_arch' | 'field_desc' | 'field_type' | 'field_uuid'>;
  }

  /**
   * Parameters for ImageLookup
   */
  export interface ImageLookupParams {
    uuid: string;
    label?: string;
  }

  /**
   * Parameters for ImageDelete
   */
  export interface ImageDeleteParams {
    uuid: string;
    volume?: string;
  }
}

export { ImageServiceService }
